import type { KeyboardShortcutHintProps } from "@/components/KeyboardShortcutHint";

export type KeyboardShortcutEntry = {
  description: string;
  hints: KeyboardShortcutHintProps[];
};

type BuildKeyboardShortcutEntriesInput = {
  showGoNav: boolean;
  /** Omit when the command palette shortcut is disabled (university staff). */
  showGoToPage?: boolean;
  addMenuItems: { label: string; chordKey: string }[];
  canViewMcpPlayground: boolean;
};

export function buildKeyboardShortcutEntries({
  showGoNav,
  showGoToPage = true,
  addMenuItems,
  canViewMcpPlayground
}: BuildKeyboardShortcutEntriesInput): KeyboardShortcutEntry[] {
  const entries: KeyboardShortcutEntry[] = [
    {
      description: "Find",
      hints: [{ keyLabel: "k", showModifier: true }]
    },
    ...(showGoToPage
      ? [
          {
            description: "Go to Page",
            hints: [{ keyLabel: "P", showModifier: true, implicitShift: true }]
          } satisfies KeyboardShortcutEntry
        ]
      : []),
    ...addMenuItems.map((item) => ({
      description: item.label,
      hints: [
        { keyLabel: "a", showModifier: false },
        { keyLabel: item.chordKey, showModifier: false }
      ]
    }))
  ];

  if (showGoNav) {
    entries.push({
      description: "Go to a main section",
      hints: [
        { keyLabel: "g", showModifier: false },
        { keyLabel: "Tab", showModifier: false }
      ]
    });
  }

  entries.push({
    description: "Focus page table search",
    hints: [{ keyLabel: "/", showModifier: false }]
  });

  if (canViewMcpPlayground) {
    entries.push({
      description: "Chat with Member 360",
      hints: [{ keyLabel: "?", showModifier: false }]
    });
  }

  entries.push({
    description: "Keyboard Shortcuts",
    hints: [{ keyLabel: "?", showModifier: true, implicitShift: true }]
  });

  return entries;
}
